import React, { useState } from 'react';
import { db } from '../firebase'; // Firebase config
import { collection, addDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const AddTouristResortPage = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [price, setPrice] = useState('');
  const [picture, setPicture] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'price') {
      setPrice(value);
    } else if (name === 'name') {
      setName(value);
    } else if (name === 'description') {
      setDescription(value);
    } else if (name === 'country') {
      setCountry(value);
    } else if (name === 'city') {
      setCity(value);
    } else if (name === 'picture') {
      setPicture(value);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('Adding Resort...');

    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        setStatus('You must be logged in to add a resort!');
        setLoading(false);
        return;
      }

      // Add new tourist resort to Firestore
      const newResort = {
        name,
        description,
        country,
        city,
        price: parseFloat(price),
        picture,
        createdBy: currentUser.uid, // Store the UID of the creator
        createdAt: new Date(),
      };

      const docRef = await addDoc(collection(db, 'touristResorts'), newResort);
      setStatus('Resort added successfully!');
      setName('');
      setDescription('');
      setCountry('');
      setCity('');
      setPrice('');
      setPicture('');
    } catch (err) {
      console.error('Error adding resort: ', err);
      setStatus('Error adding resort. Please try again.');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Add a New Tourist Resort</h2>
        <form onSubmit={handleSubmit}>
          {/* Name Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="name">
              Resort Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Description Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={description}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              rows="4"
              required
            />
          </div>

          {/* Country Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="country">
              Country
            </label>
            <input
              type="text"
              id="country"
              name="country"
              value={country}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* City Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="city">
              City
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={city}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Price Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="price">
              Price ($)
            </label>
            <input
              type="number"
              id="price"
              name="price"
              value={price}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Image URL Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="picture">
              Image URL
            </label>
            <input
              type="url"
              id="picture"
              name="picture"
              value={picture}
              onChange={handleInputChange}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Status Message */}
          {status && <p className="text-blue-500 text-sm mb-4">{status}</p>}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
            disabled={loading}
          >
            {loading ? 'Adding Resort...' : 'Add Resort'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTouristResortPage;
